import { get, post } from "../client";
import { CONTENT } from "../routes";

export default {
  get: async () => await get(CONTENT),

  create: async (data) => await post(CONTENT, data),
};
